import {
  autoPlacement,
  FloatingPortal,
  offset,
  useFloating,
  useHover,
  useInteractions,
} from "@floating-ui/react";
import { useState } from "react";
import { TooltipIcon } from "./TooltipIcon.tsx";
import styles from "./Tooltip.module.css";
import { motion } from "motion/react";
export const Tooltip: React.FC<{ text: string }> = (props) => {
  const [isOpen, setIsOpen] = useState(false);

  const { refs, floatingStyles, context } = useFloating({
    open: isOpen,
    onOpenChange: setIsOpen,
    placement: "right-start",
    middleware: [autoPlacement(), offset(10)],
  });
  const { getReferenceProps, getFloatingProps } = useInteractions([
    useHover(context),
  ]);
  return (
    <>
      <span
        ref={refs.setReference}
        {...getReferenceProps()}
        aria-label={props.text}
      >
        <TooltipIcon />
      </span>
      {isOpen && (
        <FloatingPortal>
          <motion.div
            ref={refs.setFloating}
            style={floatingStyles}
            {...getFloatingProps()}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className={styles.TooltipContent}
          >
            {props.text}
          </motion.div>
        </FloatingPortal>
      )}
    </>
  );
};
